import { createAsyncThunk } from "@reduxjs/toolkit";
import { FileHolder } from "../../../@types/fileHolder";
import axios from "axios";
import api from "../../../utils/api";
import axiosInstance from "../../../utils/axiosConfig";

export const uploadFileCompliance = createAsyncThunk(
  "uploadDocumentForCompliance",
  async (fileToUpload: FileHolder[], { rejectWithValue }) => {
    try {
        if (fileToUpload.length > 0) {
            var dateToPost = fileToUpload[0].expirationDate?.replace(/T.*/, "").split("-").reverse().join("/")
            console.log(dateToPost)
            const formData = new FormData();
           formData.append("file", fileToUpload[0].file);
            const { data: dataResponse } = await axiosInstance.post(`${api.baseURL}archive`, formData);
         
            await axiosInstance.patch(
             `${api.baseURL}archive/upload?idArchive=${dataResponse.id}&idCompliance=${fileToUpload[0].id}&idUser=${fileToUpload[0].userId}&expirationDate=${dateToPost != undefined ? dateToPost : ''}`
            );
            return dataResponse
          }
    } catch (error) {
      console.error(`Ocurrio un error: ${error}`);
    }
  }
);
